export default "__VITE_ASSET__0be3540d__"